import React, { useState } from 'react'
import styles from './styles.module.css'
import { getIcon } from '../../assets/getIcon'
import { Tooltip, message } from 'antd'
import copy from 'copy-to-clipboard'
// import imgUrl from '../../assets/images/copyCite2x.jpg'

export default function BottomEl(props) {
  const { style } = props
  const txt = [
    `1、本工具网址：http://ckdweb.chinakidney.net:8290/`,
    `2、Huai-Yu Wang, Guo-Hui Ding, Hongbo Lin, Xiaoyu Sun, Chao Yang, Suyuan
    Peng, Jinwei Wang, Jian Du, Yu Zhao, Zhengyue Chen, Beiyan Bao, Guilan
    Kong and Luxia Zhang. Influence of doctors’ perception on the diagnostic
    status of chronic kidney disease: results from 976 409 individuals with
    electronic health records in China. Clinical Kidney Journal 2021. doi:
    10.1093/ckj/sfab089`
  ]
  const [copyHover, setCopyHover] = useState(false)
  return (
    <div className={styles.zhyl_ckd_bottom} style={{ ...style }}>
      <div className={styles.zhyl_ckd_bottom_title}>
        <p>使用本工具计算结果需标明工具来源及引用下述参考文献：</p>
        <Tooltip
          title={
            <div style={{ color: '#333333', padding: '8px' }}>复制下方文献</div>
          }
          color='#E8EFF3'
          placement='right'
        >
          <div
            onMouseOver={() => {
              setCopyHover(true)
            }}
            onMouseOut={() => {
              setCopyHover(false)
            }}
            onClick={() => {
              copy(`${txt[0]}\n${txt[1]}`)
              message.success('复制成功')
            }}
          >
            <a>
              <img
                src={getIcon(!copyHover ? 'copyCite2x' : 'copyCitehover2x')}
                className={styles.zhyl_ckd_bottom_title_img}
              />
            </a>
          </div>
        </Tooltip>
      </div>
      <p
        className={styles.zhyl_ckd_bottom_title_text}
        style={{ marginTop: '12px' }}
      >
        {txt[0]}
      </p>
      <p className={styles.zhyl_ckd_bottom_title_text}>{txt[1]}</p>
    </div>
  )
}
